// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".issue-card-short{padding:6px;display:flex;gap:4px;border:1px solid var(--border-color);border-radius:6px;font-size:12px;white-space:nowrap}.issue-card-short>a{text-decoration:underline}.issue-card-short>.title{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
